import { render } from "./TheGetLocationButton.vue?vue&type=template&id=e45591b4"
import script from "./TheGetLocationButton.vue?vue&type=script&lang=js"
export * from "./TheGetLocationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__